<template>
  <div class="action_progress">
    <div class="action_progress-line" :style="{ width: progress + '%'}" />
    <span class="action_progress-text" v-if="expired">{{$t('Акция завершена')}}</span>
    <span class="action_progress-text" v-else v-text="timeString" />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { fixIsoDate } from '@/helpers'
import dayjs from 'dayjs'

const EXPIRED_EVENT = 'expired'
const MS_IN_DAY = 86400000

@Component
class OfferTimer extends Vue {
  @Prop({ type: Boolean, required: true }) expired
  @Prop({ type: String, required: true }) startDate
  @Prop({ type: String, required: true }) endDate

  timeString = ''
  progress = 0

  created () {
    this.dayjsEnd = dayjs(fixIsoDate(this.endDate))
    this.dayjsStart = dayjs(fixIsoDate(this.startDate))

    this.interval = setInterval(() => this.calculateTime(), 1000)
    this.calculateTime()
  }

  beforeDestroy () {
    this.clearCalculateTask()
  }

  clearCalculateTask () {
    clearInterval(this.interval)
  }

  calculateTime () {
    const difference = this.dayjsEnd.diff(new Date())

    if (difference > 0) {
      const timeString = dayjs(difference).utc().format('HH:mm:ss')
      const daysCount = Math.floor(difference / MS_IN_DAY)
      const daysString = this.getDaysLocalization(daysCount)

      this.timeString = `${daysString}, ${timeString}`
      this.progress = Math.round((1 - difference / this.dayjsEnd.diff(this.dayjsStart)) * 100)

      return
    }

    this.clearCalculateTask()
    this.$emit(EXPIRED_EVENT)
  }

  getDaysLocalization (daysCount) {
    const translated = this.$ngettext('%d день', '%d дней', daysCount)

    return this.$options.filters.sprintf(translated, daysCount)
  }
}

export default OfferTimer
</script>
